import { ExpandableList } from "@/components/expandableList/ExpandableList";
import { RecommendationCard } from "@/components/recommendationCard/RecommendationCard";
import { IRecommendation } from "@/interfaces/recommendation";
import React from "react";

interface RecomendationListProps {
  title: string;
  list: IRecommendation[];
  onConnect: (id: string) => void;
  dismissRecommendation: (id: string) => void;
}

export const RecommendationList: React.FC<RecomendationListProps> = ({
  title,
  list,
  onConnect,
  dismissRecommendation,
}) => {
  
  if  (!list.length) return null;
  
  return (
    <>
      <span className="cl-text-secondary fw-md fs-18">
       {title}
      </span>
      <ExpandableList>
        <ExpandableList.Content
          className="mt-20"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            rowGap: '12px',
            columnGap: '24px',
          }}
        >
          {list.map((recommendation) => (
            <RecommendationCard
              recommendation={recommendation}
              onConnect={() => onConnect(recommendation.id)}
              onDismiss={() => dismissRecommendation(recommendation.id)}
              key={recommendation.id}
            />
          ))}
        </ExpandableList.Content>
        <div className="flex flex-row mt-14 justify-flex-end">
          <ExpandableList.Trigger />
        </div>
      </ExpandableList>
    </>
  )
}